import ImmutablePropTypes from 'react-immutable-proptypes'
import { connect as connectRedux } from 'react-redux'
import compose from 'recompose/compose'
import { Map, List } from 'immutable'
import PropTypes from 'prop-types'
import React from 'react'
import { connect as connectPage, PAGE_SEO_TYPE_LOCATION } from '../../Page/connect'
import TileSubscription from '../../TileSubscription/index'
import { Tabs, Tab, TABS_TYPES } from '../../Tabs/index'
import Sherpa, { TYPE_LARGE } from '../../Sherpa/index'
import { getPrimary } from '../../../services/languages/index'
import { getBoundActions } from '../../../actions/index'
import { H2 } from '../../Heading/index'
import { getPmSectionTabs } from '../../../services/pm-section/index'

const clsSherpa = ['portals-page__sherpa']
class PortalsPage extends React.Component {
  //
  componentDidMount () {
    const { props } = this
    const { getPmScreen, user } = props
    const language = user.getIn(['data', 'language', 0], 'en')
    getPmScreen({ screenType: 'community-portals', language })
  }

  componentDidUpdate (prevProps) {
    const { props } = this
    const { user } = props
    const { user: prevUser } = prevProps
    const nextLanguage = user.getIn(['data', 'language', 0], 'en')
    const prevLanguage = prevUser.getIn(['data', 'language', 0], 'en')

    if (prevLanguage !== nextLanguage) {
      props.getPmScreen('portals', nextLanguage)
    }
  }

  renderSection (sectionId) {
    const { props } = this
    const {
      pmSection, touchable, community,
    } = props
    const tabs = getPmSectionTabs({ sectionId, pmSection })
    const firstTab = tabs.get(0)
    const communityListData = firstTab ? firstTab.get('tabContent', List()) : List() // use only uuids

    if (community.size && communityListData.size) {
      const items = communityListData.reduce((acc, item) => {
        const portal = community.find((p) => p.get('id') === item.get('uuid'))
        if (portal) return acc.push(portal)
        return acc
      }, List())

      return (
        <section className="portals-page__community" key={sectionId}>
          <ul className="portals-page__list">
            {items.map((item) => {
              const key = item.get('id')
              return (
                <TileSubscription
                  subscriberCount={item.get('subscribers')}
                  title={item.get('title')}
                  desc={item.get('tagline')}
                  hero={item.get('image')}
                  tags={item.get('tags')}
                  hoverable={!touchable}
                  url={item.get('url')}
                  key={key}
                  asListItem
                />
              )
            })}
          </ul>
        </section>
      )
    }
    return (
      <Sherpa
        className={clsSherpa}
        type={TYPE_LARGE}
        key={sectionId}
      />
    )
  }

  renderCombinedSections () {
    const { props } = this
    const { community, staticText, touchable } = props
    return (
      <Tab key={0} label={staticText.get('all')}>
        <section className="portals-page__community" key={0}>
          <ul className="portals-page__list">
            {community.reduce((acc, item) => {
              return acc.concat(
                <TileSubscription
                  subscriberCount={item.get('subscribers')}
                  title={item.get('title')}
                  desc={item.get('tagline')}
                  hero={item.get('image')}
                  tags={item.get('tags')}
                  hoverable={!touchable}
                  url={item.get('url')}
                  key={item.get('id')}
                  asListItem
                />,
              )
            }, [])}
          </ul>
        </section>
      </Tab>
    )
  }

  render () {
    const { props } = this
    const {
      pmScreen, pmSection, user, staticText,
    } = props
    const userLanguage = getPrimary(user.getIn(['data', 'language'], 'en'))
    const sectionIds = pmScreen.getIn(['community-portals', userLanguage, 'data', 'sectionIds'], List())
    return (
      <div className="portals-page">
        <div className="portals-page__container">
          <div className="portals-page__text">
            <H2>{staticText.get('explore')}</H2>
          </div>
          <div className="portals-page__grid">
            <Tabs type={TABS_TYPES.VERTICAL} activeTab={0}>
              {sectionIds.map((sectionId) => {
                const section = pmSection.getIn([sectionId, 'data'], Map())
                const sectionLabel = section.getIn(['data', 'content', 0, 'label'], null)
                return (
                  <Tab key={sectionId} label={sectionLabel}>
                    {this.renderSection(sectionId)}
                  </Tab>
                )
              }).unshift(this.renderCombinedSections())}
            </Tabs>
          </div>
        </div>
      </div>
    )
  }
}

PortalsPage.propTypes = {
  staticText: ImmutablePropTypes.map.isRequired,
  pmSection: ImmutablePropTypes.map.isRequired,
  community: ImmutablePropTypes.map.isRequired,
  pmScreen: ImmutablePropTypes.map.isRequired,
  user: ImmutablePropTypes.map.isRequired,
  getPmScreen: PropTypes.func.isRequired,
  touchable: PropTypes.bool.isRequired,
}

export default compose(
  connectPage({ seoType: PAGE_SEO_TYPE_LOCATION }),
  connectRedux(
    (state) => ({
      staticText: state.staticText.getIn(['data', 'portal', 'data'], Map()),
      touchable: state.app.getIn(['viewport', 'touchable'], false),
      community: state.portal.get('community', Map()),
      pmSection: state.pmSection,
      pmScreen: state.pmScreen,
      user: state.user,
    }),
    (dispatch) => {
      const actions = getBoundActions(dispatch)
      return {
        getPmScreen: actions.pmScreen.getPmScreen,
      }
    },
  ),
)(PortalsPage)
